/* eslint-disable max-len */
import { template_translation } from '../lang/TemplateTranslation';
const t = template_translation;

/** 18. AとBがぶつかった時 */
export const template18 = {
  title: t.to('衝突判定', 'title18'),
  desc: t.to(
    `球体をクリックすると飛び出して、青いブロックにぶつかった時にHitの文字が表示されます`,
    'desc18'
  ),
  img: '../public/template/18.png',
  xml: `<xml xmlns="http://www.w3.org/1999/xhtml">
  <variables>
  </variables>
  <block type="a-scene-start" x="230" y="110">
    <field name="is_init">off</field>
    <field name="hasController">on</field>
    <statement name="IN">
      <block type="environment_v2">
        <field name="environment">seed: 8; skyType:gradient; skyColor:#24b59f; horizonColor:#eff9b7; lighting:distant; lightPosition:-1.2 0.88 -0.55;fog: 0.8; flatShading: false; playArea: 1; ground:noise; groundYScale: 4.18; groundTexture: squares; groundColor:#937a24; groundColor2:#987d2e; dressing:trees; dressingAmount: 100; dressingColor:#888b1d; dressingScale: 1; dressingVariance:10 10 10; dressingUniformScale: true; dressingOnPlayArea: 0; grid: none; gridColor: #c5a543; shadow: false</field>
        <next>
          <block type="a-camera_v2.1">
            <field name="position-x">0</field>
            <field name="position-y">1.7</field>
            <field name="position-z">4</field>
            <field name="click_type">mouse</field>
            <next>
              <block type="sphere_v2">
                <field name="id">block1</field>
                <field name="position-x">0</field>
                <field name="position-y">1.75</field>
                <field name="position-z">1</field>
                <value name="COLOUR">
                  <shadow type="color_value_v2">
                    <field name="COLOUR">#ff0000</field>
                  </shadow>
                </value>
                <value name="ATTR">
                  <block type="scale_v2">
                    <field name="scale-x">0.5</field>
                    <field name="scale-y">0.5</field>
                    <field name="scale-z">0.5</field>
                    <value name="ATTR">
                      <block type="a-dynamic-body_v2">
                        <field name="mass">5</field>
                        <field name="shape">sphere</field>
                        <value name="ATTR">
                          <block type="push_v2">
                            <field name="power">20</field>
                          </block>
                        </value>
                      </block>
                    </value>
                  </block>
                </value>
                <next>
                  <block type="cube_v2">
                    <field name="id">block3</field>
                    <field name="position-x">0</field>
                    <field name="position-y">1.2</field>
                    <field name="position-z">-2</field>
                    <value name="COLOUR">
                      <shadow type="color_value_v2">
                        <field name="COLOUR">#1800ff</field>
                      </shadow>
                    </value>
                    <value name="ATTR">
                      <block type="scale_v2">
                        <field name="scale-x">1.5</field>
                        <field name="scale-y">2</field>
                        <field name="scale-z">0.5</field>
                        <value name="ATTR">
                          <block type="a-dynamic-body_v2">
                            <field name="mass">5</field>
                            <field name="shape">box</field>
                          </block>
                        </value>
                      </block>
                    </value>
                    <next>
                      <block type="cube_v2">
                        <field name="id">block4</field>
                        <field name="position-x">0</field>
                        <field name="position-y">1</field>
                        <field name="position-z">-1</field>
                        <value name="COLOUR">
                          <shadow type="color_value_v2">
                            <field name="COLOUR">#35952f</field>
                          </shadow>
                        </value>
                        <value name="ATTR">
                          <block type="scale_v2">
                            <field name="scale-x">6</field>
                            <field name="scale-y">0.2</field>
                            <field name="scale-z">6</field>
                            <value name="ATTR">
                              <block type="a-static-body_v2">
                              </block>
                            </value>
                          </block>
                        </value>
                      </block>
                    </next>
                  </block>
                </next>
              </block>
            </next>
          </block>
        </next>
      </block>
    </statement>
  </block>
  <block type="collide-start" x="230" y="550">
    <field name="hereId">block1</field>
    <field name="targetId">target</field>
    <statement name="IN">
      <block type="logic_if_v2">
        <value name="DECISION">
          <block type="logic_equal_v2">
            <field name="LEFT">target</field>
            <field name="RIGHT">'block3'</field>
          </block>
        </value>
        <statement name="TRUE_PART">
          <block type="a-text_v2">
            <field name="text">Hit !!!</field>
            <field name="id">block</field>
            <field name="position-x">-1</field>
            <field name="position-y">3</field>
            <field name="position-z">0</field>
            <value name="COLOUR">
              <shadow type="color_value_v2">
                <field name="COLOUR">#0e02ea</field>
              </shadow>
            </value>
            <value name="ATTR">
              <block type="scale_v2">
                <field name="scale-x">3</field>
                <field name="scale-y">1.5</field>
                <field name="scale-z">0</field>
              </block>
            </value>
          </block>
        </statement>
      </block>
    </statement>
  </block>
</xml>

`,
};
